import { StyleSheet } from 'aphrodite';
import constants from '../../../constants/styles';
let { ACCORDION_LOCATION_TEXT_COLOR, ACCORDION_CHILD_BG_COLOR } = constants;

let styles = {
  base: {
    display: 'flex',
    backgroundColor: ACCORDION_CHILD_BG_COLOR,
    padding: '20px 30px 20px 110px',
    ':last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10
    }
  },
  field: {
    fontSize: '0.8em',
    color: ACCORDION_LOCATION_TEXT_COLOR,
    fontWeight: 800,
    textTransform: 'uppercase',
    width: 200
  },
  address: {
    marginLeft: 15
  },
  options: {
    margin: 'auto 0 auto auto'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/accordionlocation/AccordionLocation.styles.js